import { createSelector } from '@ngrx/store';
import { getChartState } from 'ChartApp/ts/features/fund-chart-page-shared/state/fund-chart-base.selectors';
import { FundChartSeriesType } from 'ChartApp/ts/enums/fund-chart-common.enum';
export const getSecurities = createSelector(getChartState, ({ securities }) => securities);
export const hasSecurities = createSelector(getSecurities, (securities) => {
    return securities && securities.length;
});
// Securities Info
export const getSecuritiesInfo = ({ securitiesInfo }) => securitiesInfo;
export const hasEmptySecuritiesInfo = createSelector(getSecuritiesInfo, (securitiesInfo) => Object.keys(securitiesInfo).length === 0);
export const loadingSecurities = createSelector(hasSecurities, hasEmptySecuritiesInfo, (_hasSecurities, _hasEmptySecuritiesInfo) => _hasSecurities && _hasEmptySecuritiesInfo);
export const partitionSecuritiesAndLists = createSelector(getSecurities, (securitiesAndLists) => {
    const securities = [];
    const securityLists = [];
    securitiesAndLists.forEach((securityOrList) => {
        if (securityOrList.type === FundChartSeriesType.security) {
            securities.push(securityOrList);
        }
        else {
            securityLists.push(securityOrList);
        }
    });
    return { securities, securityLists };
});
